import React from "react";
import { AmountFormat } from "components/common/formatter";
import { useMatterBalances } from "services/matterBalancesService";

const EMPTY_BALANCES = { matterBalances: {}, clientBalances: {} };

const MatterAccount = (props) => {
  const { data } = useMatterBalances(props.clear ? null : props.matterId);
  const currentmattersBal = props.clear ? EMPTY_BALANCES : data ?? EMPTY_BALANCES;

  return (
    <table
      className={`balance-table bg-white ${props.className}`}
      style={{ maxWidth: props.width, height: "115px", paddingBottom: "10px" }}
    >
      <thead>
        <tr>
          <th>Balances</th>
          <th style={{ width: "10px" }}></th>
          <th className="text-center">Office Bal</th>
          <th className="text-center">Client Bal</th>
          <th className="text-center">DDA Bal</th>
          <th className="text-center">Unpaid Bills</th>
          <th className="text-center">WIP</th>
          <th className="text-center">U/T</th>
        </tr>
      </thead>
      <tbody>
        <tr className="position-relative">
          <td className="fs-sm fw-semibold" style={{ minWidth: "80px" }}>
            {/*{isEmpty(currentmattersBal.matterRef)*/}
            {/*  ? "Matter"*/}
            {/*  : currentmattersBal.matterRef}*/}
            {"This Matter"}
          </td>
          <td></td>
          <AmountTD value={currentmattersBal.matterBalances?.officeBalance} />
          <AmountTD value={currentmattersBal.matterBalances?.clientBalance} />
          <AmountTD value={currentmattersBal.matterBalances?.ddaBalance} />
          <AmountTD value={currentmattersBal.matterBalances?.unpaidBills} />
          <AmountTD value={currentmattersBal.matterBalances?.wipBalance} />
          <AmountTD
            value={currentmattersBal.matterBalances?.undertakingBalance}
          />
        </tr>
        <tr>
          <td className="fs-sm fw-semibold">
            {/* {isEmpty(currentmattersBal.clientRef)
              ? "Client"
              : currentmattersBal.clientRef} */}
            {"All Matters"}
          </td>
          <td></td>
          <AmountTD value={currentmattersBal.clientBalances?.officeBalance} />
          <AmountTD value={currentmattersBal.clientBalances?.clientBalance} />
          <AmountTD value={currentmattersBal.clientBalances?.ddaBalance} />
          <AmountTD value={currentmattersBal.clientBalances?.unpaidBills} />
          <AmountTD value={currentmattersBal.clientBalances?.wipBalance} />
          <AmountTD
            value={currentmattersBal.clientBalances?.undertakingBalance}
          />
        </tr>
      </tbody>
    </table>
  );
};

export default MatterAccount;

const AmountTD = ({ value }) => {
  return (
    <td
      className="text-center pe-1"
      style={{ width: "90px", whiteSpace: "nowrap", overflow: "hidden" }}
    >
      {AmountFormat(value)}
    </td>
  );
};

{
  /* <td className="bt-value w-25 text-end">{AmountFormat(value2)}</td> */
}
